const MenuFood = [
    {
        id: 1,
        MainImage: "http://northamericannature.com/wp-content/uploads/2019/09/shutterstock_123828271.jpg",
        name: "Prairie dogs kiss like us",
        category: "Food-Facts",
        description:
            "Prairie dogs are quirky creatures. They dig massive interconnected underground homes, and they kiss",
    },
    {
        id: 2,
        MainImage: "https://lionalert.org/wp-content/uploads/2020/01/Female-Lion.jpg",
        name: "Female lions - The hunters",
        category: "Food-Facts",
        description:
            "It's the female lions who do the bulk of the work when it comes to feeding their families. Lionesses, not male lions",
    },
    {
        id: 3,
        MainImage: "https://external-preview.redd.it/DA06h2Py7JYhtQytSmiqbwwVQ-mry3l4ZFYXlSKEh1c.jpg?auto=webp&s=1a6f913a1d26da3bfe27424d1ef182abe3ff9450",
        name: "Cats with superpower",
        category: "Food-Facts",
        description:
            "Some animals can predict death. Oscar the Cat is famous for his hospice work. Oscar has an uncanny ability"
    },
    {
        id: 4,
        MainImage: "https://assets3.thrillist.com/v1/image/2498969/1584x1052/scale;webp=auto;jpeg_quality=60.jpg",
        name: "Elephants can't jump",
        category: "Food-Facts",
        description:
            "Elephants are the only animal that can't jump in Earth because of it's excess weight but Bluewhale can jump"
    },
    {
        id: 5,
        MainImage: "https://www.peta.org/wp-content/uploads/2017/07/iStock-502605347_emholk-1-668x336-1564757931.jpg?20190802025851",
        name: "Cow = Milk Fountain ?",
        category: "Food-Facts",
        description:
            "A Cow gives nearly 200,000 glasses of milk which is euivalent 30,000 litre to in a lifetime"
    },
    {
        id: 6,
        MainImage: "https://cdn.vox-cdn.com/thumbor/TNtdNPS-5y7A5_nlmwlh3TSlMK8=/0x0:3000x2000/1200x800/filters:focal(1260x760:1740x1240)/cdn.vox-cdn.com/uploads/chorus_image/image/47597665/185032680.0.jpg",
        name: "Kangaroos can't fart",
        category: "Food-Facts",
        description:
            "These beasts were once the mystery of the animal kingdom -- thought to produce low-methane, environmentally friendly toots"
    },
];

export default MenuFood;